// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"f51e3713","703":"af27606a","787":"394a18a1"}[chunkId] + ".chunk.js";
};